import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n';
import classnames from 'classnames';
import {isEmpty, get} from 'lodash';
import {Form, Button} from 'ui-library';
import {emailRegex} from 'modules/legacy/js/mixins/emailRegex';
import {passwordRegex} from 'modules/legacy/js/mixins/passwordRegex';

import FormInputs from '../FormInputs';

import styles from './RoleForm.less';
import {avatarBrandImg, avatarInfluencerImg} from 'assets/images';

class RoleForms extends React.Component {
  static propTypes = {
    role: PropTypes.string,
    query: PropTypes.object.isRequired,
    onChangeRole: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  }

  static defaultProps = {
    role: null
  }

  state = {
    email: {value: get(this.props.query, 'email', ''), hasError: false},
    password: {value: '', hasError: false},
    name: {value: '', hasError: false},
    lastName: {value: '', hasError: false},
    showPassword: false,
    infErrMessage: '',
    advErrMessage: ''
  }

  isFormValid = () => {
    const {email, password} = this.state;

    const state = {};

    if (!emailRegex.test(email.value)) {
      state.email = {value: email.value, hasError: true};
      state.advErrMessage = i18n.get('REGISTER_TYPE_A_VALID_EMAIL');
      state.infErrMessage = i18n.get('REGISTER_TYPE_A_VALID_EMAIL');
    }

    if (!passwordRegex.test(password.value)) {
      state.password = {value: password.value, hasError: true};
      state.advErrMessage = i18n.get('REGISTER_INVALID_PASSWORD_LENGTH');
      state.infErrMessage = i18n.get('REGISTER_INVALID_PASSWORD_LENGTH');
    }

    if (isEmpty(state)) return true;

    this.setState(state);
    return false;
  }

  handleStateInputChange = (event, key) => {
    const {value} = event.target;
    this.setState({
      [key]: {value, hasError: false},
      advErrMessage: '',
      infErrMessage: ''
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const {onSubmit} = this.props;
    const {
      email,
      password,
      name,
      lastName
    } = this.state;

    if (!this.isFormValid()) return;

    const form = {
      email: email.value,
      password: password.value,
      name: name.value,
      lastName: lastName.value
    };
    onSubmit(form);
  }

  render() {
    const {
      role,
      onChangeRole
    } = this.props;

    const {
      email,
      password,
      showPassword,
      infErrMessage,
      advErrMessage
    } = this.state;

    if (!role) {
      return (
        <RolesDescription
          onChangeRole={onChangeRole}
        />
      );
    }

    const influencerPillClassName = classnames(styles['role-btn'], {
      [styles.active]: role === 'influencer'
    });

    const advertiserPillClassName = classnames(styles['role-btn'], {
      [styles.active]: role === 'advertiser'
    });

    return (
      <div className='width100'>
        <div className='width100'>
          <div className='flex width100 between-xs role-selector margin-top-2x'>
            <Button
              className={influencerPillClassName}
              onClick={() => onChangeRole('influencer')}
            >
              {i18n.get('REGISTER_IM_INFLUENCER')}
            </Button>

            <Button
              className={advertiserPillClassName}
              onClick={() => onChangeRole('advertiser')}
            >
              {i18n.get('REGISTER_IM_A_BRAND')}
            </Button>
          </div>
        </div>

        <Form
          autoComplete='off'
          className='margin-top-2x'
          onSubmit={this.handleSubmit}
        >
          <FormInputs
            email={email}
            password={password}
            showPassword={showPassword}
            onInputChange={this.handleStateInputChange}
            onShowPassword={() => this.setState({showPassword: !showPassword})}
          />

          <div className='vf-text-danger margin-top-1x'>
            {role === 'influencer' ? infErrMessage : advErrMessage}
          </div>

          <div id='recaptcha' className='recaptcha-container' ref='recaptcha' />

          <div className='flex flex-start'>
            <div className='vf-text-secondary vf-font-bold margin-right-1x vf-clickable'>
              {i18n.getHTML('REGISTER_ACCEPT_TOS')}
            </div>
            <Button
              color='primary'
              type='submit'
              style={{marginLeft: 'auto', borderRadius: '2px'}}
            >
              {i18n.get('REGISTER_REGISTER_ME')}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

export default RoleForms;

const RolesDescription = ({onChangeRole}) => (
  <div className='flex flex-column'>
    <div
      data-uitest='influencer-card'
      className='role-descriptor margin-vertical-1x flex flex-row'
      onClick={() => onChangeRole('influencer')}
    >
      <img alt='' src={avatarInfluencerImg} />

      <div className='padding-left-2x start-xs'>
        <h3 className='vf-text-black'>{i18n.get('REGISTER_INFLUENCER')}</h3>
        <span>{i18n.get('REGISTER_I_WANT_TO_PARTICIPATE_IN_CAMPAIGNS')}</span>
      </div>
    </div>

    <div
      data-uitest='advertiser-card'
      className='role-descriptor margin-vertical-1x flex flex-row'
      onClick={() => onChangeRole('advertiser')}
    >
      <img alt='' src={avatarBrandImg} />

      <div className='padding-left-2x start-xs'>
        <h3 className='vf-text-black'>{i18n.get('REGISTER_BRAND')}</h3>
        <span>{i18n.get('REGISTER_I_WANT_TO_PROMOTE_MY_BRAND')}</span>
      </div>
    </div>
  </div>
);

RolesDescription.propTypes = {
  onChangeRole: PropTypes.func.isRequired
};
